import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import FreeEntryInputArea from './FreeEntryInputArea.react';
import './free-entry-question.scss';

const FreeEntryQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customHeader={customHeader}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={FreeEntryInputArea}
    />
  );
};

type FreeEntryQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const FreeEntryQuestion = {
  PreGuess: (props: FreeEntryQuestionTypeProps) => (
    <FreeEntryQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: FreeEntryQuestionTypeProps) => (
    <FreeEntryQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {FreeEntryQuestion};
